import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { adminRoutes, privateRoutes, publicRoutes } from "./Config/routes";
import "./App.css";
import PopupSnackbar from "./Components/PopupSnackbar";
import AdminRoute from "./Utils/AdminRoute";
import { getToken } from "./Utils/Common";
import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";
import { useStyles } from "./Utils/Styles";

const renderRoutes = (RouteComponent, routes) =>
  routes.map(({ path, title, icon, sidebarTitle, sidebarIcon, ...routeProps }) => (
    <RouteComponent key={path} path={path} {...routeProps} />
  ));

export default function App(props) {
  const classes = useStyles();
  useEffect(() => {
    setTimeout(
      () => {
        // This timeout triggers after 25 hours and makes sure that when the token expires the user is forced to relogin
        window.location.reload();
      },
      1000 * 60 * 60 * 25,
    );
  }, []);
  return (
    <React.Fragment>
      <PopupSnackbar />
      <div className={classes.root}>
        <Switch>
          <Route exact path="/">
            {getToken() ? (
              <Redirect to={{ pathname: "/dashboard" }} />
            ) : (
              <Redirect to={{ pathname: "/login" }} />
            )}
          </Route>
          {renderRoutes(AdminRoute, adminRoutes)}
          {renderRoutes(PrivateRoute, privateRoutes)}
          {renderRoutes(PublicRoute, publicRoutes)}
        </Switch>
      </div>
    </React.Fragment>
  );
}
